var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 13.5L12 7.5M12 7.5L6 1.5M12 7.5L0 7.5","stroke":_vm.getAssets.primaryBrandColor || '#000000',"stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }